import {
    CLEAR_URL_ADMINISTRATOR
} from '../constants'

export function reducer(state, action) {
    if (action.type === CLEAR_URL_ADMINISTRATOR) {
        return {...state, urlPaymentsAdministrator: false}
    } else {
        return state
    }
}